import * as React from 'react';
import { ReportViewer } from '../Components/Reports/Agency/ReportViewer';
import { REPORT_TYPE } from '../Enums/AGENCY_REPORT_TYPE';
import type { ReportType } from '../Constants/AgencyReports';
import { sections } from '../Constants/AgencyReports';

export interface AgencyBookPageProps {
  userId: number;
  userAccessToken: string;
  agencyId: number;
  uplineId?: number;
  absoluteUplineId?: number;
  contractsInherited: boolean;
}

/**
 * Page component for AgencyBook
 *
 * @component
 * @author Andrew Brown <abrown@medicareprocrm.com>
 * @date Created: 2025-06-16
 * @lastUpdated
 * @version 1.1.0
 */

export default function AgencyBookPage(props: AgencyBookPageProps): React.JSX.Element {
  const [selectedReportType, setSelectedReportType] = React.useState<ReportType>(sections[0]);

  return (
    <>
      <div className="row">
        <div className="col col-lg-2">
          <div className="card" style={{ height: 'auto' }}>
            <div className="card-header font-weight-bold py-2 cp">Reports</div>
            <div className="card-body mt-4">
              {sections.map((section) => (
                <div
                  key={section.id}
                  className={`mb-3 cp ${selectedReportType.id === section.id ? 'text-primary' : ''}`}
                  id={section.id}
                  onClick={() => setSelectedReportType(section)}
                >
                  {' '}
                  <i className="far fa-list mr-2"></i>
                  {section.label}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-10 mb-2">
          {
            <ReportViewer
              userId={props.userId}
              userAccessToken={props.userAccessToken}
              agencyId={props.agencyId}
              selectedReportType={selectedReportType}
              contractsInherited={props.contractsInherited}
              absoluteUplineId={props.absoluteUplineId}
            />
          }
        </div>
      </div>
    </>
  );
}
